
// Libraries
import { Col, Container, Navbar, Row, Button, Tab, Tabs } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { AnimatePresence, m } from 'framer-motion'
import { Form, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useState, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
// Components
import MessageBox from "../../Components/MessageBox/MessageBox";
import Buttons from '../../Components/Button/Buttons'
import { Checkbox, Input, TextArea } from '../../Components/Form/Form'
import API from '../../Api/Api';
import ButtonsVariant from '../../Components/Button/ButtonVariant'; // Fixed: Use default import

const Home = (props) => {
    const form = useRef(null)
    const [successMsg, setSuccessMsg] = React.useState(false);
    const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
    const recaptchaRef = useRef();

    // useEffect(() => {
    //     console.log("reCAPTCHA script is assumed to be loaded via index.html");
    // }, []);

    const handleRecaptchaChange = (value) => {
        setIsRecaptchaVerified(!!value);
    };

    const ContactFormStyle03Schema = Yup.object().shape({
        name: Yup.string().required("Field is required."),
        email: Yup.string().email("Invalid email.").required("Field is required."),
        phone: Yup.string()
            .required("Phone number is required.")
            .matches(/^\d+$/, "Only numbers are allowed.")
            .max(12, "Phone number can't exceed 12 digits."),
        comment: Yup.string()
            .required("Your message is required.")
            .max(500, "Message can't exceed 500 characters."),
        terms_condition: Yup.boolean()
            .oneOf([true], "You must accept the terms & conditions.")
            .required("Field is required."),
        recaptcha: Yup.bool()
            .oneOf([true], "Please verify the reCAPTCHA")
            .required("reCAPTCHA is required"),
    });


    const resetForm = (actions) => {
        actions.resetForm();
        actions.setSubmitting(false);
    };

    const sendEmailFor = async (values) => {
        if (!isRecaptchaVerified) return;
        try {
            const payload = {
                name: values.name,
                email: values.email,
                phone: values.phone || '', // Optional field
                message: values.comment || '', // Optional field
                terms_condition: values.terms_condition || false, // Optional field
            };

            // Dummy API call to jsonplaceholder
            const response = await API.post('/contactUs/contact', payload);

            // Return success if the API call succeeds
            return { status: 'success', data: response.data };
        } catch (error) {
            console.error('Error sending email:', error);
            return { status: 'error', message: error.message };
        }
    };


    return (<>

        <Col className="col-xl-10 col-sm-12 col-xs-12">
            <Formik
                initialValues={{ name: '', email: '', phone: '', comment: '', terms_condition: false, recaptcha: false }}
                validationSchema={ContactFormStyle03Schema}
                onSubmit={async (values, actions) => {
                    actions.setSubmitting(true);
                    const response = await sendEmailFor(values);
                    if (response.status === 'success') {
                        setSuccessMsg(true);  // ✅ show the message
                        resetForm(actions);
                        setTimeout(() => setSuccessMsg(false), 5000); // auto-hide after 5s
                    } else {
                        actions.setSubmitting(false);
                    }
                    setIsRecaptchaVerified(false);
                    recaptchaRef.current?.reset();
                }}
            >
                {({ isSubmitting, status, setFieldValue }) => (
                    <Form ref={form}>
                        <Row className="row-cols-1 row-cols-md-2">
                            <Col className=" sm:mb-[25px]">
                                <Input
                                    showErrorMsg={true}
                                    type="text"
                                    name="name"
                                    className="py-[15px] px-[20px] text-md w-full border-[1px] border-solid border-[#dfdfdf]"
                                    labelClass="mb-[27px]"
                                    placeholder="Your name"
                                />

                                <Input
                                    showErrorMsg={true}
                                    type="email"
                                    name="email"
                                    className="py-[15px] px-[20px] w-full text-md border-[1px] border-solid border-[#dfdfdf]"
                                    labelClass="mb-[27px]"
                                    placeholder="Your email address"
                                />
                                <Input
                                    showErrorMsg={true}
                                    type="tel"
                                    name="phone"
                                    labelClass="mb-[17px]"
                                    className="py-[15px] px-[20px] w-full text-md border-[1px] border-solid border-[#dfdfdf]"
                                    placeholder="Mobile number"
                                />
                            </Col>
                            <Col className=" sm:mb-[20px]">
                                <TextArea
                                    showErrorMsg={true}
                                    className="border-[1px] border-solid border-[#dfdfdf] w-full py-[15px] px-[20px] text-md h-[210px] resize-none"
                                    rows="6"
                                    labelClass="mb-[17px]"
                                    name="comment"
                                    placeholder="Your message"
                                />
                            </Col>
                            <Col lg={12} className="text-left sm:mb-[20px] mb-[17px]">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6LeMeB0rAAAAANu99dAvFdegQ5rV6L-8plZSr4Fa"
                                    onChange={(value) => {
                                        handleRecaptchaChange(value);
                                        setFieldValue("recaptcha", !!value);
                                    }}
                                    className=""
                                />
                                <ErrorMessage
                                    name="recaptcha"
                                    component="div"
                                    className="text-error text-sm mt-0 text-left"
                                />
                            </Col>

                            <Col className="text-left sm:mb-[20px]">
                                <Checkbox
                                    showErrorMsg={true}
                                    type="checkbox"
                                    name="terms_condition"
                                    className="inline-block mt-[4px]"
                                    labelClass="flex items-start"
                                >
                                    <span className="ml-[10px] text-sm inline-block w-[85%]">
                                        I accept the terms & conditions and I understand that my data will be held securely in accordance with the{' '}
                                        <Link
                                            aria-label="checkbox"
                                            to="/privacy"
                                            target="_blank"
                                            className="text-darkgray underline hover:text-fastblue"
                                        >
                                            privacy policy
                                        </Link>.
                                    </span>
                                </Checkbox>
                            </Col>
                            <Col className="text-right sm:text-center">
                                {/* <Buttons
                                    type="submit"
                                    className={`btn-explore-white-glogin bto${isSubmitting ? ' loading' : ''}`}
                                    title="Send Message"
                                /> */}
                                <ButtonsVariant
                                    ariaLabel="submit-button"
                                    type="submit"
                                    //   href="#"
                                    className={`mx-[10px] ${isSubmitting ? ' loading' : ''}`}
                                    variant="whiteToBlack"
                                    size="md"
                                    title="Send Message"
                                />

                            </Col>
                        </Row>
                        <AnimatePresence>
                            {successMsg && (
                                <Row>
                                    <Col xs={12}>
                                        <m.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            exit={{ opacity: 0 }}
                                        >
                                            <MessageBox
                                                className="mt-[20px] py-[10px]"
                                                theme="message-box01"
                                                variant="success"
                                                message="Your message has been sent successfully!"
                                            />
                                        </m.div>
                                    </Col>
                                </Row>
                            )}
                        </AnimatePresence>

                    </Form>
                )}
            </Formik>
        </Col>
    </>
    )
}

export default Home